import styled from '@emotion/styled';


export const PageWrapper = styled.div`
    padding: 24px 0;
`;

export const PageHeader = styled.div`
    color: #0f172a;
    font-weight: 600;
    font-size: 1rem;
    line-height: 2.6;
`;

export const ConfigurationManagerContainer = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.25fr);
    gap: 0 10px;
    justify-content: space-between;
    padding: 12px 0;
`;
